import { render, staticRenderFns } from "./ScanBarcode.vue?vue&type=template&id=593a5057"
import script from "./ScanBarcode.vue?vue&type=script&lang=js"
export * from "./ScanBarcode.vue?vue&type=script&lang=js"
import style0 from "./ScanBarcode.vue?vue&type=style&index=0&id=593a5057&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports